import { useChargeEventNotification } from '@services/notification'
import { Button, Select } from '@shared/Form'
import useSearch from '@shared/innmaxLib/hooks/useSearch'
import { Layout, Table } from '@shared/innmaxUI'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'src/components/Form'
import OptionsSelect from 'src/components/OptionsSelect'

const NotificationReport = () => {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const { query, handleTableChange, handleSearch } = useSearch({
    form,
    transform: v => ({
      deep: true,
      ...v,
    }),
  })
  const { dataSource, loading } = useChargeEventNotification(query)

  const columns = [
    {
      title: '時間',
      dataIndex: 'createAtStr',
      key: 'createAtStr',
    },
    {
      title: '事件',
      dataIndex: 'eventStr',
      key: 'eventStr',
    },
    {
      title: '內容',
      dataIndex: 'content',
      key: 'content',
    },
  ]

  return (
    <Layout>
      <Form layout="inline" form={form}>
        <FormItem label={'航廈/站點'} name="sessionId" className="w-[280px]">
          <OptionsSelect.CityAreaSelect
            className="w-130"
            supportAll
            allowAllArea
            allowClear
          />
        </FormItem>

        <FormItem label={'通知事件'} name="event" className="w-[140px]">
          <Select allowClear placeholder="請選擇通知事件" className="w-full">
            <Select.Option value="CHARGE_80">充電量達 80%</Select.Option>
            <Select.Option value="CHARGE_100">充電量達 100%</Select.Option>
            <Select.Option value="OCCUPY">佔用事件</Select.Option>
          </Select>
        </FormItem>

        <FormItem.Button>
          <Button
            loading={false}
            type="primary"
            className="w-96"
            onClick={handleSearch}>
            {t('common:search')}
          </Button>
        </FormItem.Button>
      </Form>
      <div>
        <div className="mt-44 mb-16">
          <Table.RowCount count={dataSource?.total || 0} />
        </div>
        <Table
          simpleMode
          scroll={{ x: 'max-content' }}
          columns={columns}
          loading={loading}
          dataSource={dataSource || []}
          onChange={handleTableChange}
          pagination={{
            total: dataSource.total,
            pageSize: dataSource.pageSize,
            current: dataSource.page,
          }}
        />
      </div>
    </Layout>
  )
}

export default NotificationReport
